import {
  Alert as FobAlert,
  AlertTitle as FobAlertTitle,
} from "ra-friendsofbabba";

import React from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslate } from "ra-core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
}));
const Alert = ({ title, message, color, severity }) => {
  const translate = useTranslate();
  const classes = useStyles();
  return (
    <FobAlert color={color} severity={severity} className={classes.root}>
      {title && <FobAlertTitle>{translate(title)}</FobAlertTitle>}
      <div
        dangerouslySetInnerHTML={{
          __html: translate(message),
        }}
      />
    </FobAlert>
  );
};

export default Alert;
